import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IUserResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IUserResponseInstance'
import {
  mapDatabaseTimeTrackerItemResponseInstance,
} from '@toolify/client/src/modules/api/singletons/mapDatabaseTimeTrackerItemResponseInstance'

export function mapUserResponseInstance(user: IToJson<IUserResponseInstance>): IUserResponseInstance {
  return {
    ...user,
    activeDatabaseTimeTrackerItem: user?.activeDatabaseTimeTrackerItem ? mapDatabaseTimeTrackerItemResponseInstance(user.activeDatabaseTimeTrackerItem) : null,
  }
}
